// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `Inteligência de Mercado`,
    h229e7d06093c2f3f: html `ESG e Diversidade`,
    h4b6568de605796be: html `Conselhos de Administração e Governança`,
    h4e84df3b11ed9b4f: html `Ajuda e Suporte`,
    h722c4148bfbe6706: html `Educação e certificações`,
    h85f4df4fdcb8beed: html `Risco e Estratégia`,
    hb6b70f369f25a7ac: html `Conformidade e Ética`,
    hc639dc8eaab7815d: html `Problemas e Relatórios`,
    hcd22a6d6c40d8786: html `Auditoria e Análises`,
    "link-home": `Home`,
    "nav-section-home": `Home`,
    s032cd9f1245d3645: `Espaço`,
    s08e6d298452e8f68: `Auditoria`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `Caixa de diálogo Abrir atalhos de teclado`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `Inventário de Ativos`,
    s14ba513bc8896c24: `Robôs`,
    s1534ff9f453525e1: `Selecionar primeira célula`,
    s175d37c8eb04d73e: `Downloads`,
    s1967ea0b8a2b6015: `Executar célula selecionada`,
    s199f5853f4e718f7: `Projetos`,
    s24761a0cc8d9c0aa: `Organização`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `Rolar para cima`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `Caixa de diálogo Abrir seletor de organização`,
    s2e109263b73c12d5: `Licenças`,
    s34d94212c9758944: `Estratégia`,
    s353873ecbaa3efe9: `Seta para a esquerda`,
    s3736464cf8d6fa08: `Suporte`,
    s392dc2954562a82b: `Editor de texto`,
    s39cccc90e6fe1d7f: `Gerenciador de Problemas`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `Último slide`,
    s3f809b62bcc2a44c: `Controle da Missão`,
    s45efff328e4d0a4d: `Pesquisar organizações`,
    s460bf77c46d93bb4: `Caixa de diálogo Fechar atalhos`,
    s469437ae00d48e37: `Expandir a linha atual`,
    s47de2481b149190a: `Entidades`,
    s4802e47fe2e95134: `Opção`,
    s480d27b7a8b69ce5: `Rolar para a esquerda`,
    s49ca4bf0e63593da: `Fechar caixa de diálogo`,
    s4b10acae683d2978: `Tela cheia`,
    s4b81aa9512692c4d: `Recolher navegação lateral`,
    s523eb9043213ff0d: `Itálico`,
    s56410a6c80d5215c: `Mover célula para baixo`,
    s58622fa7922ed03b: `Botão do menu Ajuda`,
    s586d6bd2eca2da93: `Usuários`,
    s5a41c3a63f1c18af: `Configurações de Perfil`,
    s5b56a21c08c842c4: `Primeiro slide`,
    s5c1ecf88259b79f9: `Apresentação`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `Mapas de Conformidade`,
    s5d929ff1619ac0c9: `Pesquisar`,
    s5db46d120dcba694: `Avaliações`,
    s5e27738a2e8eb763: `Entrar`,
    s5e8250fb85d64c23: `Fechar`,
    s5febcd9b311c16fe: `Rolar para a direita`,
    s60565faf8db3a5cb: `Executar esta célula e todas acima`,
    s62bc518b503d1c76: `Selecionar célula abaixo`,
    s63b6edf663b6a3c5: `Adicionar célula abaixo`,
    s6d5cb7af3fa87c78: `Rastreador de Tarefas`,
    s6db55a42bcb74cfc: `Rastreador de Problemas`,
    s6fb3409caa74b0a4: `Ctrl`,
    s70113bbc33303a81: `Menu Ajuda`,
    s7417792bbe720149: `Refazer`,
    s74cb3d66f6a668e1: `Documentação`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `Sair`,
    s7db511600050e797: `Executar esta célula e todas abaixo`,
    s7deaf226ff8b192c: `Instaladores`,
    s7e388025be643d0d: `Enter`,
    s7eb1e34fc5ece4cd: `Menu Perfil`,
    s884bcdca26998a48: `Relatórios`,
    s89365ba6fa5cdb97: `Parar a execução`,
    s89ba33f94f92f3cc: `Campanhas de identificação`,
    s8f4be9f086eb530f: `Desfazer`,
    s9021935bcdd703b9: `Abrir um painel lateral`,
    s9373ade6d85b4388: `Recolher a linha atual`,
    s947f21967d65c480: `Marketplace`,
    s9ab2385df7adbce0: `Realçar uma linha`,
    s9dd12575273ac110: `Rolar para baixo`,
    s9df9510d60035af3: `Abrir menu Perfil`,
    s9f26843287bb592d: `Grupos`,
    s9fda4232f5e1876a: `Obter ajuda`,
    sa05b93d8764f88ed: `Gerenciador de Riscos`,
    sa103c8e0c776e11c: `Solicitar atalhos de teclado`,
    sa153c163bc11460d: `Centro de Atividades`,
    sa35ed9234d3d66ce: `Nenhuma organização encontrada`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `Estrutura org`,
    saed6432f1517ea10: `Gerenciador de Ativos`,
    saf7a5eef69e5bb59: `Seta para cima`,
    sb061ff5a347a296e: `Perfil`,
    sb206d700d26b14ff: `Sublinhado`,
    sb21cca7db5de38f3: `Storyboards`,
    sb284cd019b430d1e: `Não há atalhos específicos do aplicativo disponíveis.`,
    sb32c8490570a8831: `Visão geral do slide`,
    sb4484b8d878dffff: `Registros de Atividades`,
    sb752d83c4e4619bc: str `Mudar para ${0}`,
    sb888017adf7992b9: `Diligent Academy`,
    sbd63362a31200ab4: `Ir para Launchpad`,
    sbda32dab0c54ffdd: `Próximo slide`,
    sbf84c104b8212e06: `Selecionar célula acima`,
    sc203eef710f83583: `Não há suporte para atalhos específicos para esse aplicativo.`,
    sc2873891e8c3be68: `Editor de script do Robôs`,
    sc835e30bc3bdd2fd: `Mover célula para cima`,
    sc8aa5792985e2ba3: `Configurações da plataforma`,
    sca1a826088564455: `Resultados`,
    sca442b5dc0fd394c: `Seta para baixo`,
    scdd4399eeeacd8f4: `Mudar organização`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `Selecionar tudo`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `Navegação lateral`,
    sd1c09a62f063a73b: `Gerenciador de Tarefas`,
    sd514ab1c93237dae: `Planos de Garantia`,
    sd76505ffae553332: `Portal de pesquisa`,
    sd81eecf773db25fc: `Executar todas as células sequencialmente`,
    sd8f923198e0c5c6a: `End`,
    sd90a1e198e1ac71e: `Esc`,
    sd9fb2375a5c991c5: `Não há compatibilidade com atalhos específicos para esse aplicativo, mas se tiver sugestões, fale conosco.`,
    sdc599e1d5c823e75: `Selecionar última célula`,
    sdcc5f064d591aefd: `Slide anterior`,
    se2faf168207b0a48: `Estruturas`,
    se3b4c857f91f80d7: `Atalhos de teclado`,
    se65e4e6f3696e997: `Treinamento`,
    se93a3eaf86201ae7: `Shift`,
    sed2d45e3f811c81d: `Básico`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `Excluir célula selecionada`,
    sf2d615b20d62225a: `Agendador`,
    sf41a0c89409353dc: `Seta para a direita`,
    sf5597bb9f2103d2a: `Ativações`,
    sf7c0eba7c822e3d6: `Negrito`,
    sf95b10c03a2d5872: `Abrir navegação lateral`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `Configuração`,
    sfc6b9ce43d2c798c: `Quadros de Horário`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Home`,
};
